module.exports = __webpack_public_path__ + "catalog/items/kitchen/Double-sink-with-drainer/Double-sink-with-drainer.svg";